module.exports = __webpack_public_path__ + "static/img/view10-8.92bb51b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view10-8.png
// module id = DDtu
// module chunks = 1